<template>
    <div class="mainTabs-wrapper rank-refresh">
        <!-- ✅ Main Tab View -->
        <div v-show="isStarmateBoxVisible">
            <div id="parentTabIn" class="parentTabIn">
                <!-- Back -->
                <span class="backArrowIcon" id="close" @click="viewClose('someStatus')">
                    <img :src="downArrow" alt="Back Arrow" loading="lazy" />
                </span>

                <!-- Tabs -->
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" v-for="tab in tabs" :key="tab.id" :style="tab.hidden ? 'display:none' : ''">
                        <button type="button" class="nav-link" :class="{ active: activeTab === tab.id }"
                            @click="activateTab(tab.id)" ref="tabButtons">
                            {{ tab.label }}
                        </button>
                    </li>
                </ul>

                <!-- Info Icon -->
                <div id="rankRewardInfoTab__" v-if="activeTab !== 'topGameTab' && activeTab !== 'richTab'" @click="showRankRewardInfoTab">
                    <div class="header-infoIcon">
                        <img :src="infoIcon" alt="Info Icon" loading="lazy" />
                    </div>
                </div>
            </div>

            <!-- ✅ Tab Contents -->
            <div class="tab-content">
                <div class="tab-pane" :class="{ 'active active': activeTab === 'charmTab' }">
                    <div class="tab-contentIn" v-if="loadedTabs.charmTab">
                        <keep-alive>
                            <Charm v-if="activeTab === 'charmTab'" />
                        </keep-alive>
                    </div>
                </div>

                <div class="tab-pane" :class="{ 'active active': activeTab === 'richTab' }">
                    <div class="tab-contentIn" v-if="loadedTabs.richTab">
                        <keep-alive>
                            <Rich v-if="activeTab === 'richTab'" />
                        </keep-alive>
                    </div>
                </div>

                <div class="tab-pane" :class="{ 'active active': activeTab === 'roomTab' }">
                    <div class="tab-contentIn" v-if="loadedTabs.roomTab">
                        <keep-alive>
                            <Room v-if="activeTab === 'roomTab'" />
                        </keep-alive>
                    </div>
                </div>

                <div class="tab-pane" :class="{ 'active active': activeTab === 'callTab' }">
                    <div class="tab-contentIn" v-if="loadedTabs.callTab">
                        <keep-alive>
                            <Call v-if="activeTab === 'callTab'" />
                        </keep-alive>
                    </div>
                </div>

                <div class="tab-pane" :class="{ 'active active': activeTab === 'agencyTab' }">
                    <div class="tab-contentIn" v-if="loadedTabs.agencyTab">
                        <keep-alive>
                            <Agency v-if="activeTab === 'agencyTab'" />
                        </keep-alive>
                    </div>
                </div>

                <div class="tab-pane" :class="{ 'active active': activeTab === 'topGameTab' }">
                    <div class="tab-contentIn" v-if="loadedTabs.topGameTab">
                        <keep-alive>
                            <TopGames_2 v-if="activeTab === 'topGameTab'" />
                        </keep-alive>
                    </div>
                </div>
            </div>
        </div>

        <!-- ✅ Rank Reward Info Tab -->
        <div id="rankRewardInfoTab" v-show="isRankRewardInfoTabVisible">
            <div class="tab-contentIn">
                <div>
                    <div class="headerWrapper rankRewardTopSec">
                        <div id="goParentTab" @click="activateTab('charmTab')" class="backArrowIcon">
                            <img :src="downArrow" alt="Back Arrow" loading="lazy" />
                        </div>

                        <div class="rankingReward-HD">Ranking Rewards</div>
                    </div>

                    <div class="rankRewardContSec" v-if="loadedTabs.rankRewardInfoTab">
                        <RankRewardInfoComponent :currentTab="activeTab" @tab-changed="handleTabChange" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { viewClose as androidViewClose } from '@/utils/android';
import "../../assets/css/ranking-refresh.css";
import downArrow from "../../assets/images/back-blackArrow.svg";
import infoIcon from "../../assets/images/infoIcon.png";
import { defineAsyncComponent } from "vue";

export default {
    name: "ParentTabComponent",

    components: {
        Charm: defineAsyncComponent(() => import("../Charm/CharmCompTab.vue")),
        Rich: defineAsyncComponent(() => import("../Rich/RichCompTab.vue")),
        Room: defineAsyncComponent(() => import("../Room/RoomCompTab.vue")),
        Call: defineAsyncComponent(() => import("../Call/CallCompTab.vue")),
        Agency: defineAsyncComponent(() => import("../Agency/AgencyCompTab.vue")),
        TopGames_2: defineAsyncComponent(() => import("../TopGames_2/TopGames_2.vue")),
        RankRewardInfoComponent: defineAsyncComponent(() =>
            import("../RankRewardInfoComponent/RankRewardInfoComponent.vue")
        ),
    },

    data() {
        return {
            downArrow,
            infoIcon,

            activeTab: "charmTab",
            isStarmateBoxVisible: true,
            isRankRewardInfoTabVisible: false,

            tabs: [
                { id: "charmTab", label: "Charm", hidden: false },
                { id: "richTab", label: "Rich", hidden: false },
                { id: "roomTab", label: "Room", hidden: true },
                { id: "callTab", label: "Call", hidden: false },
                { id: "agencyTab", label: "Agency", hidden: true },
                { id: "topGameTab", label: "Game", hidden: true },
            ],

            loadedTabs: {
                charmTab: true,
                richTab: false,
                roomTab: false,
                callTab: false,
                agencyTab: false,
                topGameTab: false,
                rankRewardInfoTab: false,
            },
        };
    },

    mounted() {
        // ✅ Prefetch next likely tab after UI is ready (FAST switch)
        if ("requestIdleCallback" in window) {
            requestIdleCallback(() => {
                import("../Rich/RichCompTab.vue");
            });
        } else {
            setTimeout(() => {
                import("../Rich/RichCompTab.vue");
            }, 500);
        }
    },

    beforeUnmount() {
        document.body.classList.remove("topGameActive");
    },

    methods: {
        showRankRewardInfoTab() {
            this.isRankRewardInfoTabVisible = true;
            this.isStarmateBoxVisible = false;
            this.loadedTabs.rankRewardInfoTab = true;
        },

        activateTab(tabId) {
            this.isRankRewardInfoTabVisible = false;
            this.isStarmateBoxVisible = true;

            this.activeTab = tabId;
            this.loadedTabs[tabId] = true;

            // ✅ body class
            if (tabId === "topGameTab") document.body.classList.add("topGameActive");
            else document.body.classList.remove("topGameActive");

            // ✅ Smooth scroll into view
            this.$nextTick(() => {
                const buttons = this.$refs.tabButtons;
                if (Array.isArray(buttons)) {
                    const btn = buttons.find((b) => b.classList.contains("active"));
                    btn?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
                }
            });
        },

        handleTabChange(tabId) {
            this.activateTab(tabId);
        },

        viewClose(status) {
            if (window.Android && typeof Android.viewClose === "function") {
                androidViewClose(status);
            } else if (
                window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.viewClose
            ) {
                window.webkit.messageHandlers.viewClose.postMessage({ status });
            } else {
                window.parent.postMessage({ action: "closePopup", status }, "*");
            }
        },
    },
};
</script>
